const _temp0 = require("../animation-disabler/animation-disabler-style.css");

const _temp1 = require("../frame-overlay/frame-overlay-style.css");

const _temp2 = require("../footer/footer-style.css");

const _temp3 = require("../menu/ menu-sticky-style.css");
const _temp4 = require("../menu/menu-style.css");
const _temp5 = require("../menu/menu-trigger-style.css");

const _temp6 = require("../parallax-group/parallax-group-style.css");

const _temp7 = require("../scrollable-feed/scrollable-feed-style.css");

const _temp8 = require("../title-button-pair/title-button-pair-style.css");

const _temp9 = require("../vertical-heading/vertical-heading-style.css");

const _temp10 = require("../wp-forms/wp-forms-style.css");

const _temp11 = require("../wp-overrides/wp-style.css");

module.exports = {
  "animation-disabler":   {
    "animation-disabler-": _temp0
  },
  "frame-overlay":   {
    "frame-overlay-": _temp1
  },
  "footer":   {
    "footer-": _temp2
  },
  "menu":   {
    " menu-sticky-": _temp3,
    "menu-": _temp4,
    "menu-trigger-": _temp5
  },
  "parallax-group":   {
    "parallax-group-": _temp6
  },
  "scrollable-feed":   {
    "scrollable-feed-": _temp7
  },
  "title-button-pair":   {
    "title-button-pair-": _temp8
  },
  "vertical-heading":   {
    "vertical-heading-": _temp9
  },
  "wp-forms":   {
    "wp-forms-": _temp10
  },
  "wp-overrides":   {
    "wp-": _temp11
  }
}